








import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryEnergyContributionStatList,ExportEnergyContributionStat } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'

@Component({
  components: {
    VQuery,
    VTable,
  },
})
export default class EnergyContributionStatList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
    statDateDaterange:[],
    orderBy: 'stat_date desc',
    statDateTimeScope:'',
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [{ title: '统计日期', param: 'statDateDaterange', type: 'daterange' }]
  // 全局操作
  private queryOperation: Array<TableOperation> = [{ title: '导出', type: 'warning', click: this.exportHandle }]
  // 数据表头 -
  private tableHander: Array<TableHander> = [
    { title: '多选', type: 'selection' },
    { title: '序号', param: 'id', type: 'index' },
    { title: '统计日期', param: 'statDate',width:120 },
    { title: '期初能量值', param: 'initialEnergy' },
    { title: '期末能量值', param: 'finalEnergy' },
    { title: '能量值总额', param: 'todayChangeEnergy' },
    { title: '能量值消耗', param: 'todayConsumeEnergy' },
    { title: '能量值产生', param: 'todayProduceEnergy' },
    { title: '期初贡献值', param: 'initialContribution' },
    { title: '期末贡献值', param: 'finalContribution' },
    { title: '贡献值总额', param: 'todayChangeContribution' },
    { title: '贡献值消耗', param: 'todayConsumeContribution' },
    { title: '贡献值产生', param: 'todayProduceContribution' },

    { title: '数据更新时间', param: 'updateTime', formatter: DateFormat,width:160 },
    {
      title: '操作',
      fixed: 'right',
      width:180,
      operation: [
        { title: '能量值明细' , click: this.jumpToEnergy},
        { title: '贡献值明细' , click: this.jumpToContribution},
      ],
    },
  ]

  private jumpToEnergy(data: any){
    // 跳转到数据源，用户积分记录，加入查询条件，和查询一直
    this.$router.push({
      path: "/userWealthRecordList",
      query:{
        finishTime: data.statDate,
        type: '2'
      }
    })
  }
  private jumpToContribution(data: any){
    // 跳转到数据源，用户积分记录，加入查询条件，和查询一直
    this.$router.push({
      path: "/userWealthRecordList",
      query:{
        finishTime: data.statDate,
        type: '1'
      }
    })
  }

  private tableSelectData: any[] = []
  private tableSelectChange(e:any[]){
    this.tableSelectData = e
  }
  private exportHandle(){

    const loading = this.$loading({
          lock: true,
          text: '正在导出',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      const param: any = this.getRequestParam()
      param.limit = ""
      param.startRow = ""

      if(this.tableSelectData.length > 0){
        const ids = this.tableSelectData.map(e=>e.id)
        param.ids = ids
      }


      ExportEnergyContributionStat(param,"每日能量值/贡献值数据统计.xlsx").then(res=>{
        loading.close()
      }).catch(()=>{
        loading.close()
      })

  }

  public async created() {
    this.loadData()
  }


  public async loadData() {
    const param = this.getRequestParam()
    const result = await QueryEnergyContributionStatList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }
  private getRequestParam(){
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    if (param.statDateDaterange.length >0) {
      param.statDateTimeScope = DateFormat(param.statDateDaterange[0]) + ',' + DateFormat(param.statDateDaterange[1])
    }
    return param
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
